import clsx from 'clsx';
import styles from '../RelatedParties.module.scss';
import { infoIconGray } from '../../../../../assets/hostedassets';
import Tooltip from '../../../../../common/_custom/Tooltip/Tooltip';
import { getImage, getRelatedPartyHeaders } from '../relatedParty_constants';
import type { RptParty } from '../../../../../store/dashboard/relatedParties/relatedPartyTransactions.types';
import RptTransactionsCell from './RptTransactionsCell';
import DirectorHoverCardTooltip from '../components/DirectorHoverCard/DirectorHoverCardTooltip';
import EntityHoverCardTooltip from '../components/EntityHoverCard/EntityHoverCardTooltip';
import {
    rptEntityKid,
    toNoDataEntityHoverProfile,
    toRptHoverRow,
    toRptNoDataExtras,
} from '../components/EntityHoverCard/toEntityHoverProfile';
import EntityNameCell, { EntityNameLabel } from '../components/EntityNameCell/EntityNameCell';
import DisabledAlertsCell from '../components/DisabledAlertsCell/DisabledAlertsCell';
import { OTHER_KMP_TITLE, OTHER_KMP_TOOLTIP, RPT_BUCKET } from './relatedPartyTransactions_constants';

function OtherKmpGroup({ parties, onOpenRpt }: { parties: RptParty[]; onOpenRpt: (party: RptParty) => void }) {
    if (!parties.length) return null;
    return (
        <>
            <tr>
                <td colSpan={getRelatedPartyHeaders(false).length} className={styles.EdgeGroupType}>
                    <span className={styles.EdgeGroupTitle}>
                        {OTHER_KMP_TITLE}
                        <Tooltip content={OTHER_KMP_TOOLTIP} direction="top" fitContent small usePortal>
                            <img src={infoIconGray} alt="info" className={styles.EdgeGroupInfo} />
                        </Tooltip>
                    </span>
                </td>
            </tr>
            {parties.map((party) => (
                <tr key={party.partyKey} className={clsx(styles.FirstDegreeRow, styles.FirstDegreeRow_Static)}>
                    <td className={styles.RowItem}>
                        <EntityNameCell caret={{ disabled: true }}>
                            <PartyNameHoverTooltip party={party}>
                                <EntityNameLabel
                                    name={party.partyName}
                                    iconSrc={getImage(party.bucket === RPT_BUCKET.INDIVIDUAL ? 'PERSON' : 'COMPANY')}
                                />
                            </PartyNameHoverTooltip>
                        </EntityNameCell>
                    </td>
                    <td className={styles.RowItem} />
                    <td className={styles.RowItem} />
                    <td className={styles.RowItem} />
                    <td className={styles.RowItem} />
                    <td className={styles.RowItem}>
                        <RptTransactionsCell party={party} onOpen={onOpenRpt} />
                    </td>
                    <td className={styles.RowItem}>
                        <DisabledAlertsCell />
                    </td>
                </tr>
            ))}
        </>
    );
}

/** Person card for an individual, the full card for a CIN/LLPIN party polus stamped, else the no-data company card; a blank name keeps the bare label. */
function PartyNameHoverTooltip({ party, children }: { party: RptParty; children: React.ReactNode }) {
    if (!party.partyName.trim()) return <DirectorHoverCardTooltip fallback={party.partyName}>{children}</DirectorHoverCardTooltip>;
    if (party.bucket === RPT_BUCKET.INDIVIDUAL) {
        return (
            <DirectorHoverCardTooltip
                unmatched={{ name: party.partyName, designation: party.relationship ?? undefined, din: party.partyKid ?? undefined }}
            >
                {children}
            </DirectorHoverCardTooltip>
        );
    }
    if (rptEntityKid(party) && (party.aicaStatus || party.entityDetails)) {
        return <EntityHoverCardTooltip row={toRptHoverRow(party)}>{children}</EntityHoverCardTooltip>;
    }
    return (
        <EntityHoverCardTooltip profile={toNoDataEntityHoverProfile(party.partyName, party.partyName, toRptNoDataExtras(party))}>
            {children}
        </EntityHoverCardTooltip>
    );
}

export default OtherKmpGroup;
